/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./auction-approval.styles.scss";

import dayjs from "dayjs";
import { ReactComponent as CloseIcon } from "../../assets/cancel.svg";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";

import {
  CheckOutlined,
  DeleteOutlined,
  EditOutlined,
  SyncOutlined,
} from "@ant-design/icons";

import { connect, useDispatch } from "react-redux";
import { createStructuredSelector } from "reselect";

import {
  selectBagtypeList,
  selectBranchParams,
  selectBranches,
  selectCrops,
  selectCurrentPage,
  selectDefaultParams,
  selectDivisionList,
  selectFreezingTime,
  selectMinQty,
  selectRebates,
  selectSelectedBranch,
  selectSelectedCrop,
  selectVarieties,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";
// import { setBranchIndex } from "../../redux/common/common.actions";

// import { getSysParams } from "../../services/sys-params-services";

import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  approveAuction,
  cancelAuction,
  editAuction,
  getUpcomingAuction,
} from "../../services/auction-services";
import {
  getRebateMatrixService,
  getRebateService,
  // getRebateService,
} from "../../services/common-services";

import { FeatureCodes } from "../../constants/data-constants";
import { canUserAccess } from "../../utils/utils";
// import { getCompanyParams } from "../../services/sys-params-services";
import {
  Table,
  message,
  Modal,
  Button,
  Select,
  Input,
  // Popover,
  Checkbox,
  Flex,
  Space,
  TableProps,
} from "antd";
// import { Dispatch } from "redux";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import { setSelectedCrop } from "../../redux/common/common.actions";
import { useLocation } from "react-router";
// import { setInterval } from "timers";

const { confirm } = Modal;
const { Option } = Select;

const editDefault = {
  qty_rqd: undefined,
  rebate_matrix_id: undefined,
  auction_id: undefined,
  bagType: undefined,
  maxPrice: undefined,
  division: undefined,
  variety: undefined,
};

const ApproveAuction: React.FC = (props: any) => {
  let ApproveAuctionsIntervalID = useRef<NodeJS.Timeout>();
  const {
    branches,
    selectedCropId,
    user,
    globalSocketData,
    crops,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setBranch,
    // auth,
    freezingTime,
    parametersData,
    selectedBranchId,
    minQuantity,
    rebates,
    divisions,
    bagType,
    varieties,
  } = props;
  const [searchText, setSearchText] = useState("");
  const [upcomingData, setUpcomingData] = useState<any>([]);
  const [selectedData, setSelectedData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [valueToEdit, setValueToEdit] = useState<any>(editDefault);
  const [rebateModalVisible, setRebateModalVisible] = useState(false);
  const [modalconfirmation, setModalConfirmation] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [rebateTableData, setRebateTableData] = useState<Array<any>>();
  const [rebateList, setRebateList] = useState<any>([]);
  const [error, setError] = useState<String>("");
  const dispatch = useDispatch();
  const location = useLocation();
  let timer = useRef<NodeJS.Timeout>();
  let timeout = useRef<NodeJS.Timeout>();
  const TableColumnHeader = (props: any) => {
    const { title, subtitle } = props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontWeight: 400,
            // color: "white",
            fontSize: "12px",
            textAlign: "left",
            marginLeft: "0px",
            justifyContent: "flex-start",
            float: "left",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#cbdfff",
            fontSize: "8px",
            fontWeight: "normal",
            textAlign: "left",
          }}
        >
          {subtitle}
        </div>
      </div>
    );
  };
  const rowSelection: TableProps<any>["rowSelection"] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      // console.log(
      //   `selectedRowKeys: ${selectedRowKeys}`,
      //   "selectedRows: ",
      //   selectedRows
      // );
      // const modifiedData =
      //   upcomingData && upcomingData.length
      //     ? upcomingData.map((item: any) => {
      //         if (
      //           dayjs(
      //             dayjs(new Date(), "HH:mm:ss").add(freezingTime, "minutes"),
      //             "HH:mm:ss"
      //           ).isBefore(dayjs(item.startTime, "HH:mm:ss"))
      //         ) {
      //           return item.id;
      //         }
      //       })
      //     : [];
      if (selectedRowKeys) {
        setSelectedData(selectedRowKeys);
      } else {
        setSelectedData([]);
      }
    },
    getCheckboxProps: (record: any) => ({
      disabled:
        !canUserAccess(user, FeatureCodes.AUCTION_CHECKER) ||
        dayjs(
          dayjs(new Date(), "HH:mm:ss").add(freezingTime, "minutes"),
          "HH:mm:ss"
        ).isBefore(dayjs(record.startTime, "HH:mm:ss")), // Column configuration not to be checked
      id: record.id,
    }),
  };

  const columns = [
    {
      title: "ID",
      sorter: (a, b) => a.id - b.id,
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Hub",
      sorter: (a, b) => a.hub.localeCompare(b.hub),
      dataIndex: "hub",
      key: "hub",
    },
    {
      title: "Division",
      sorter: (a, b) => a.division - b.division,
      dataIndex: "division",
      key: "division",
      // align: "center",
      render: (value: number) => {
        return <div>{value === 1 ? "ABD" : value === 2 ? "FBD" : "NCDEX"}</div>;
      },
    },
    {
      title: "Claim",
      dataIndex: "claim",
      key: "claim",
      render: (value: number) => {
        return (
          <div className="claim-container">
            {value === 1 ? <CheckedIcon /> : <CloseIcon />}
          </div>
        );
      },
    },
    {
      title: "Variety",
      sorter: (a, b) => a.variety.localeCompare(b.variety),
      dataIndex: "variety",
      key: "variety",
    },
    {
      title: `Qty Reqd (${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "qtyReqd",
      key: "qtyReqd",
    },
    {
      title: `Max Price (₹/${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "maxPrice",
      key: "maxPrice",
    },
    {
      title: "Sauda Type",
      dataIndex: "saudhaType",
      key: "saudhaType",
      render: (value: number) => {
        return <div>{value === 1 ? "Net basis" : "Gross basis"}</div>;
      },
    },
    {
      title: "Role",
      dataIndex: "roleType",
      key: "Role",
      render: (value: number) => {
        return (
          <div style={{ whiteSpace: "break-spaces" }}>
            {value === 1
              ? "Broker / Trader"
              : value === 2
              ? "FPO"
              : value === 3
              ? "Broker/Trader & FPO"
              : "Not Selected"}
          </div>
        );
      },
    },
    {
      title: "Start Time",
      dataIndex: "startTime",
      key: "startTime",
      render: (value: string) => {
        return <div>{dayjs(value, "HH:mm:ss").format("hh:mm A")}</div>;
      },
    },
    {
      title: "End Time",
      dataIndex: "endTime",
      key: "endtime2",
      render: (value: string) => {
        return <div>{dayjs(value, "HH:mm:ss").format("hh:mm A")}</div>;
      },
    },
    {
      title: "Rake Sauda",
      dataIndex: "auction_type",
      key: "auction_type",
      render: (value: any) => {
        return <div>{value == 2 || value == 3 ? "Y" : "N"}</div>;
      },
    },
    {
      title: "Rebate Name",
      dataIndex: "rebateName",
      key: "rebateName",
      render: (value: number, row: any) => {
        return (
          <div
            className={"rebate-info-upcoming"}
            style={{ whiteSpace: "break-spaces" }}
          >
            {value}
            {value && (
              <span
                className="info"
                onClick={() => {
                  getRebateMatrix(row.rebateId, selectedBranch);
                }}
              >
                ?
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Material Code",
      dataIndex: "materialCode",
      key: "materialCode",
      render: (value: number, row: any) => {
        return <div>{value}</div>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (value: boolean, rowData: any) => {
        return (
          <div>
            <span
              className={`edit-container ${
                canUserAccess(user, FeatureCodes.AUCTION_CHECKER) ||
                canUserAccess(user, FeatureCodes.AUCTION_MAKER)
                  ? ""
                  : "disabled"
              }`}
              style={{ paddingInline: "0 10px" }}
              onClick={() => onEditClicked(rowData)}
            >
              <EditOutlined />
            </span>
            <span
              className="cancel-container"
              onClick={() =>
                !canUserAccess(user, FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS) &&
                showPromiseConfirm(rowData.key, rowData.startTime)
              }
              style={{ paddingInline: "10px 0" }}
            >
              <DeleteOutlined />
            </span>
          </div>
        );
      },
    },
    // {
    //   title: (
    //     <div
    //       style={{
    //         fontSize: "8px",
    //         color: "white",
    //         display: "flex",
    //         flexDirection: "row",
    //         justifyContent: "space-between",
    //         width: "100%",
    //         paddingRight: "13px",
    //         marginRight: "10px",
    //       }}
    //     >
    //       {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
    //         canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
    //         <>
    //           {/* <TableColumnHeader
    //             title="Select All"
    //             style={{ marginLeft: "0px" }}
    //           /> */}
    //           <div
    //             style={{
    //               display: "flex",
    //             }}
    //           >
    //             <Checkbox
    //               style={{ margin: "auto" }}
    //               checked={
    //                 upcomingData &&
    //                 upcomingData.length !== 0 &&
    //                 (upcomingData && upcomingData.length) ===
    //                   (selectedData && selectedData.length)
    //               }
    //               disabled={
    //                 canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
    //                   ? false
    //                   : true
    //               }
    //               onChange={(e) => {
    //                 let count = 0;
    //                 const modifiedData =
    //                   upcomingData && upcomingData.length
    //                     ? upcomingData.map((item: any) => {
    //                         if (
    //                           dayjs(
    //                             dayjs(new Date(), "HH:mm:ss").add(
    //                               freezingTime,
    //                               "minutes"
    //                             ),
    //                             "HH:mm:ss"
    //                           ).isBefore(dayjs(item.startTime, "HH:mm:ss"))
    //                         ) {
    //                           return item.id;
    //                         }
    //                       })
    //                     : [];
    //                 if (e.target.checked === true) {
    //                   setSelectedData(modifiedData);
    //                 } else {
    //                   setSelectedData([]);
    //                 }
    //               }}
    //             />
    //           </div>
    //         </>
    //       )}
    //     </div>
    //   ),
    //   key: "action",
    //   dataIndex: "action",
    //   render: (value: number, row: any) => {
    //     return (
    //       <div className="approval-table-checkbox">
    //         {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
    //           canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
    //           <Checkbox
    //             checked={
    //               Array.isArray(selectedData) && selectedData.includes(row.id)
    //             }
    //             disabled={
    //               canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
    //                 ? false
    //                 : true
    //             }
    //             onChange={(e) => {
    //               if (
    //                 dayjs(
    //                   dayjs(new Date(), "HH:mm:ss").add(
    //                     freezingTime,
    //                     "minutes"
    //                   ),
    //                   "HH:mm:ss"
    //                 ).isAfter(dayjs(row.startTime, "HH:mm:ss"))
    //               ) {
    //                 message.error(
    //                   "cannot approve the auction during freezing period"
    //                 );
    //               } else {
    //                 if (e.target.checked === true) {
    //                   setSelectedData([...selectedData, row.id]);
    //                 } else {
    //                   const temp = selectedData.filter(
    //                     (item) => item !== row.id
    //                   );
    //                   setSelectedData(temp);
    //                 }
    //               }
    //             }}
    //           />
    //         )}
    //       </div>
    //     );
    //   },
    // },
  ];
  const filteredData = useMemo(() => {
    if (!searchText) return upcomingData;

    return upcomingData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [upcomingData, searchText]);
  useEffect(() => {
    if (modalconfirmation) {
      timer.current = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      timeout.current = setTimeout(() => {
        onCheckBoxChange(upcomingData, "multi");
        clearInterval(timer.current as NodeJS.Timeout);
        setModalConfirmation(false);
      }, 10000);
    } else {
      clearTimeout(timeout.current as NodeJS.Timeout);
      clearInterval(timer.current as NodeJS.Timeout);
    }
    return () => clearInterval(timer.current as NodeJS.Timeout);
  }, [modalconfirmation]);

  useEffect(() => {
    // if (currentpage == "3" && viewAuctionPage === "30" && globalSocketData) {
    if (
      location.pathname.includes("/viewauction/approve") &&
      globalSocketData
    ) {
      ApproveAuctionsIntervalID.current &&
        clearInterval(ApproveAuctionsIntervalID.current);
      // onBranchChange(selectedBranch, []);
      // getParamsMinQty({ branch_id: selectedBranch, crop_id: selectedCropId });
      ApproveAuctionsDataSocketEmition();
      ApproveAuctionsIntervalID.current = setInterval(() => {
        ApproveAuctionsDataSocketEmition();
      }, 10000);
    }
    return () => {
      ApproveAuctionsIntervalID.current &&
        clearInterval(ApproveAuctionsIntervalID.current);
    };
  }, [
    currentpage,
    viewAuctionPage,
    globalSocketData,
    selectedBranch,
    selectedCropId,
  ]);

  /**
   *
   * @function
   * @description Establish socket.io connection for getting auction cards data.
   * @memberof App.MainLayout
   */
  const ApproveAuctionsDataSocketEmition = () => {
    if (globalSocketData) {
      globalSocketData.emit("tm_approval_auction_event", {
        crop_id: selectedCropId,
        branch_id: selectedBranch,
        approval_status: 0,
      });
      // setIsLoading(true);
      globalSocketData.on("tm_approval_auctions", (data: any) => {
        const modifiedData = data.map((item: any) => {
          return {
            key: item.auction_id,
            id: item.auction_id,
            hub: item.hub_name,
            division: item.division,
            claim: item.claim_type,
            variety: item.variety_name,
            qtyReqd: item.qty_rqd,
            maxPrice: item.max_price,
            saudhaType: item.saudha_type,
            roleType: item.role_mapping,
            rebateName: item.rebate_name,
            startTime: item.start_time,
            endTime: item.end_time,
            rebateId: item.rebate_id,
            checked: false,
            bagType: item.bag_type,
            minPrice: item.min_price,
            materialCode: item.material_code,
            brokerage: item.brokerage,
            auction_type: item.auction_type,
          };
        });
        setUpcomingData(modifiedData);
        setIsLoading(false);
      });
    }
  };

  const onEditClicked = async (data: any) => {
    if (
      dayjs(
        dayjs(new Date(), "HH:mm:ss").add(freezingTime, "minutes"),
        "HH:mm:ss"
      ).isAfter(dayjs(data.startTime, "HH:mm:ss"))
    ) {
      message.error("cannot edit the auction during freezing period");
    } else {
      setValueToEdit({
        qty_rqd: data.qtyReqd,
        rebate_matrix_id: data.rebateId,
        auction_id: data.id,
        claim: data.claim,
        maxPrice: data.maxPrice,
        division: data.division,
        bagType: data.bagType,
        variety: data.variety,
        auction_type: data.auction_type,
      });

      const rebateParams = {
        crop_id: selectedCropId,
        branch_id: selectedBranch,
        variety_id: varieties.filter(
          (item: any) => item.name === data.variety
        )[0].id,
        division: divisions.filter((item: any) => item.id === data.division)[0]
          .name,
      };
      getVarietyData(rebateParams);
      setIsEdit(true);
    }
  };
  const getVarietyData = async (params: any) => {
    try {
      const rebateListResponse = await getRebateService(params);
      if (rebateListResponse.data.status) {
        setRebateList(rebateListResponse.data.data);
      }
    } catch (error) {
      console.warn("error", error);
    }
  };

  const cancelAuctionFn = async (auctionId: number, startTime: any) => {
    const dataToSend = {
      auction_id_list: [auctionId],
    };

    if (
      dayjs(
        dayjs(new Date(), "HH:mm:ss").add(freezingTime, "minutes"),
        "HH:mm:ss"
      ).isAfter(dayjs(startTime, "HH:mm:ss"))
    ) {
      message.error("cannot cancel the auction during freezing period");
    } else {
      try {
        const response = await cancelAuction(dataToSend);
        if (response.data.status) {
          message.success("Auction cancelled successfully...!");
          // await getUpcomingData(selectedBranch);
          ApproveAuctionsDataSocketEmition();
        } else message.warning("Cannot cancel auction...!");
      } catch (error) {
        console.log(error);
      }
    }
  };

  const onCancelClick = async (dataToPut: any) => {
    setIsLoading(true);
    dataToPut = dataToPut
      .map((element: any) => {
        if (selectedData.includes(element.id)) return element;
        else return undefined;
      })
      .filter((item: any) => item !== undefined);

    const list = dataToPut.map((eachRow: any) => {
      return eachRow.id;
    });

    if (list !== undefined && list !== null && list !== "" && list.length > 0) {
      const reqBody = {
        auction_id_list: list,
      };
      try {
        const response = await cancelAuction(reqBody);
        if (response.data.status) {
          message.success("Auction cancelled successfully...!");
          setSelectedData([]);
          ApproveAuctionsDataSocketEmition();
        } else {
          message.warning("Cannot cancel auction...!");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      message.error("Select atleast one row.", 2);
    }
    setIsLoading(false);
  };

  function showPromiseConfirm(auctionId: number, startTime: any) {
    confirm({
      title: "Cancel Auction",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you want to cancel the auction ?",
      okText: "Yes",
      cancelText: "No",
      onOk() {
        cancelAuctionFn(auctionId, startTime);
      },
      onCancel() {},
    });
  }

  const getRebateMatrix = async (
    rebateId: string,
    branchId: number | undefined
  ) => {
    const params = {
      rebate_id: rebateId,
      branch_id: branchId,
      crop_id: selectedCropId,
    };
    try {
      const response = await getRebateMatrixService(params);
      if (response.data.status) {
        setRebateModalVisible(true);
        setRebateTableData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const rebateColumns = [
    {
      title: "Head",
      dataIndex: "head",
      key: "head",
      render(_: any, row: any) {
        return {
          children: row.head,
          props: {
            rowSpan: row.rowSpan,
          },
        };
      },
    },
    {
      title: "Slab",
      dataIndex: "slab",
      key: "slab",
    },
    {
      title: "Rebate",
      dataIndex: "rate_display",
      key: "rate_display",
    },
  ];
  const createNewArr = (data: any) => {
    if (data)
      return data
        .reduce((result: any, item: any) => {
          //First, take the name field as a new array result
          if (result.indexOf(item.head) < 0) {
            result.push(item.head);
          }
          return result;
        }, [])
        .reduce((result: any, head: any) => {
          //Take the data with the same name as a new array, and add a new field * * rowSpan inside it**
          const children = data.filter((item: any) => item.head === head);
          result = result.concat(
            children.map((item: any, index: any) => ({
              ...item,
              rowSpan: index === 0 ? children.length : 0, //Add the first row of data to the rowSpan field
            }))
          );
          return result;
        }, []);
  };

  const updateAuction = async () => {
    try {
      // if (Number(valueToEdit.qty_rqd) >= Number(minQuantity)) {
      let matrix_id = {};
      if (valueToEdit.rebate_matrix_id) {
        matrix_id = { rebate_matrix_id: valueToEdit.rebate_matrix_id };
      }
      const maxPrice = varieties.filter(
        (item: any) => item.name === valueToEdit.variety
      )[0].maxPrice;
      const minPrice = varieties.filter(
        (item: any) => item.name === valueToEdit.variety
      )[0].minPrice;
      if (
        Number(valueToEdit.maxPrice) <= minPrice ||
        Number(valueToEdit.maxPrice) >= maxPrice
      ) {
        message.warning(
          `Max price should be between the range ${minPrice} (₹/${
            crops?.find((item) => item.id == selectedCropId)?.unit
          }) to ${maxPrice} (₹/${
            crops?.find((item) => item.id == selectedCropId)?.unit
          })...`
        );
        return false;
      }
      const param = {
        qty_rqd:
          valueToEdit.qty_rqd !== null ||
          valueToEdit.qty_rqd !== undefined ||
          valueToEdit.qty_rqd !== ""
            ? Number(valueToEdit.qty_rqd)
            : 0,
        ...matrix_id,
        auction_id: valueToEdit.auction_id,
        max_price: Number(valueToEdit.maxPrice),
        bag_type: valueToEdit.bagType,
        division: valueToEdit.division,
      };
      const response = await editAuction(param);
      if (response.data.status) {
        message.success("Updated auction successfully..!");
        // await getUpcomingData(selectedBranch);
        ApproveAuctionsDataSocketEmition();
        setIsEdit(false);
        setError("");
      } else message.error("Could not update auction..!");
      /* } else {
        message.error(
          `Quantity can not be lower than minimum truckable quantity : ${minQuantity}`
        );
      } */
    } catch (error: any) {
      console.log(error);
      message.error(
        error.response.data.message || "Could not update auction..!"
      );
    }
  };

  const onCheckBoxChange = async (dataToPut: any, key: any) => {
    setIsLoading(true);
    // if (key === "multi") {
    console.log(dataToPut);
    dataToPut = dataToPut
      .map((element: any) => {
        if (selectedData.includes(element.id)) return element;
        else return undefined;
      })
      .filter((item: any) => item !== undefined);
    // }

    // if (validate(dataToPut)) {
    const list = dataToPut.map((eachRow: any) => {
      return eachRow.id;
    });

    if (list !== undefined && list !== null && list !== "" && list.length > 0) {
      const reqBody = {
        auction_id_list: list,
      };

      try {
        const response = await approveAuction(reqBody);
        if (response.data.status) {
          message.success(response.data.message);
          // await getUpcomingData(selectedBranch);
          setSelectedData([]);
          ApproveAuctionsDataSocketEmition();
        } else {
          console.log("error while submit");
          message.warning("Cannot approve auction...!");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      message.error("Select atleast one row.", 2);
    }
    setIsLoading(false);
  };

  return (
    <div className="approve-auction">
      <Modal
        className="edit-modal"
        open={isEdit}
        onCancel={() => {
          setIsEdit(false);
          setValueToEdit(editDefault);
          setError("");
        }}
        footer={false}
        maskClosable={false}
      >
        <div className="header">Edit Auction</div>
        <div className="form-container">
          <div className={`form-items`}>
            <div className="label">
              Quantity ({crops?.find((item) => item.id == selectedCropId)?.unit}
              )
            </div>
            {valueToEdit.auction_type == 3 ? (
              <Select
                placeholder="Slot Qty"
                value={valueToEdit.qty_rqd}
                onChange={(e) => {
                  setValueToEdit((prevState: any) => ({
                    ...prevState,
                    qty_rqd: e,
                  }));
                }}
                options={[
                  {
                    value: Number(parametersData?.rj_container_bid_full_rake),
                    label: parametersData?.rj_container_bid_full_rake,
                  },
                  {
                    value: Number(parametersData?.rj_container_bid_half_rake),
                    label: parametersData?.rj_container_bid_half_rake,
                  },
                ]}
              />
            ) : (
              <Input
                value={valueToEdit.qty_rqd}
                type="number"
                placeholder="Slot Qty"
                onChange={(e) => {
                  setValueToEdit((prevState: any) => ({
                    ...prevState,
                    qty_rqd: e.target.value,
                  }));
                }}
                onBlur={(e: any) => {
                  if (
                    valueToEdit.auction_type == 2 &&
                    !/^\d+(\.5)?$/.test(
                      `${e.target.value / parametersData.full_rake}`
                    )
                  ) {
                    message.warning("Enter Valid Quantity...!");
                    setValueToEdit((prevState: any) => ({
                      ...prevState,
                      qty_rqd: "",
                    }));
                  }
                }}
              />
            )}
            <p style={{ color: "red" }} className="label">
              {error}
            </p>
          </div>

          {valueToEdit.claim === 1 && (
            <div className={`form-items`}>
              <div className="label help">
                Rebate Name
                <div
                  className="info"
                  onClick={() => {
                    getRebateMatrix(
                      valueToEdit.rebate_matrix_id,
                      selectedBranch
                    );
                  }}
                >
                  ?
                </div>
              </div>

              <Select
                placeholder="Rebate Name"
                showSearch
                filterOption={(inputValue, option: any) =>
                  option.children
                    .toLowerCase()
                    .indexOf(inputValue.toLowerCase()) >= 0
                }
                value={valueToEdit.rebate_matrix_id}
                onChange={(value) =>
                  setValueToEdit((prevState: any) => ({
                    ...prevState,
                    rebate_matrix_id: value,
                  }))
                }
              >
                {rebateList &&
                  rebateList.map((item: any) => (
                    <Option
                      value={item.rebate_id}
                      id={item.rebate_id}
                      key={item.rebate_id}
                    >
                      {item.rebate_name}
                    </Option>
                  ))}
              </Select>
            </div>
          )}
          <div className={`form-items`}>
            <div className="label">
              Max Price (₹/
              {crops?.find((item) => item.id == selectedCropId)?.unit})
            </div>
            <Input
              value={valueToEdit.maxPrice}
              type="number"
              placeholder="Max Price"
              onChange={(e) => {
                setValueToEdit((prevState: any) => ({
                  ...prevState,
                  maxPrice: e.target.value,
                }));
              }}
            />
          </div>
          <div className={`form-items`}>
            <div className="label help">Division</div>
            <Select
              placeholder="Division"
              showSearch
              filterOption={(inputValue, option: any) =>
                option.children
                  .toLowerCase()
                  .indexOf(inputValue.toLowerCase()) >= 0
              }
              value={valueToEdit.division}
              onChange={(value) =>
                setValueToEdit((prevState: any) => ({
                  ...prevState,
                  division: value,
                }))
              }
            >
              {divisions &&
                divisions.map((item: any) => (
                  <Option value={item.id} id={item.id} key={item.id}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </div>
          <div className={`form-items`}>
            <div className="label help">Bag Type</div>
            <Select
              placeholder="Bag Type"
              showSearch
              filterOption={(inputValue, option: any) =>
                option.children
                  .toLowerCase()
                  .indexOf(inputValue.toLowerCase()) >= 0
              }
              value={valueToEdit.bagType}
              onChange={(value) =>
                setValueToEdit((prevState: any) => ({
                  ...prevState,
                  bagType: value,
                }))
              }
            >
              {bagType &&
                bagType.map((item: any) => (
                  <Option value={item.id} id={item.id} key={item.id}>
                    {item.name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
        <div className="update-btn-container">
          <Button
            onClick={updateAuction}
            disabled={canUserAccess(
              user,
              FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
            )}
          >
            Update
          </Button>
        </div>
      </Modal>

      <Modal
        className="rebate-modal"
        open={rebateModalVisible}
        onCancel={() => setRebateModalVisible(false)}
        footer={false}
        zIndex={1001}
      >
        <div className="rebate-header">Rebate Matrix</div>
        <div className="rebate-container">
          <Table
            size="small"
            columns={rebateColumns}
            // dataSource={tableData}
            dataSource={createNewArr(rebateTableData)}
            pagination={false}
            scroll={{ y: window.innerHeight - 165 }}
          />
        </div>
      </Modal>
      <Modal
        className="temporal-modal"
        title="Alert !"
        open={modalconfirmation}
        closable={false}
        maskClosable={false}
        okText={`Confirm ${countdown}s`}
        cancelText="Go Back"
        style={{ textAlign: "center" }}
        maskStyle={{ opacity: "1" }}
        centered
        okButtonProps={{
          style: { backgroundColor: "#20346a", border: 0 },
        }}
        cancelButtonProps={{
          danger: true,
          type: "dashed",
        }}
        onOk={() => {
          (async () => {
            setModalConfirmation(false);
            onCheckBoxChange(upcomingData, "multi");
          })();
        }}
        onCancel={() => setModalConfirmation(false)}
      >
        <div style={{ color: "black" }}>
          Are you sure that the rebate versions selected for auction creation
          are the latest available in SAP?
        </div>
      </Modal>
      <div className="label noteText">
        <b>
          {parametersData !== undefined && parametersData !== null
            ? ` NOTE: Auction cannot be Edited or Approved ${parametersData.auction_freeze_period} minute(s) before the start time.`
            : ""}
        </b>
      </div>
      <Flex>
        <Space wrap>
          <Input.Search
            placeholder="Search..."
            allowClear
            onSearch={setSearchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "15em" }}
            variant="outlined"
          />
          <CustomFilter
            type="single-select"
            value={selectedBranchId}
            options={branches}
            onChange={(value: any) => setBranch(value)}
            head="ITC Branch Office"
            returnId
          />
          <CustomFilter
            type="single-select"
            value={selectedCropId}
            options={crops}
            onChange={(value: any) => {
              dispatch(setSelectedCrop(value));
            }}
            head="Crops"
            returnId
          />
        </Space>
        <Space>
          {upcomingData.length !== 0 && (
            <div
              style={{
                display: "flex",
                // justifyContent: "flex-end",
                width: "100%",
              }}
            >
              {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
                canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
                <Button
                  // className={
                  //   canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
                  //     ? "submit-btn"
                  //     : "submit-btn disabled"
                  // }
                  type="primary"
                  disabled={
                    canUserAccess(
                      user,
                      FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                    ) || !canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
                  }
                  onClick={() => {
                    // onCheckBoxChange(upcomingData, "multi");
                    setModalConfirmation(true);
                    setCountdown(10);
                  }}
                  loading={modalconfirmation}
                  style={{ background: "rgba(72, 172, 51, 1)" }}
                  icon={<CheckOutlined />}
                >
                  Accept All/ Accept Selected
                </Button>
              )}
              {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
                canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
                <Button
                  className={
                    canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
                      ? "cancel-btn"
                      : "cancel-btn disabled"
                  }
                  style={{ marginLeft: 10 }}
                  disabled={canUserAccess(
                    user,
                    FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
                  )}
                  onClick={() => {
                    confirm({
                      title: "Cancel Auction",
                      icon: <ExclamationCircleOutlined />,
                      content:
                        "Are you sure you want to cancel the selected auction ?",
                      okText: "Yes",
                      cancelText: "No",
                      onOk() {
                        onCancelClick(upcomingData);
                      },
                      onCancel() {},
                    });
                  }}
                >
                  Cancel
                </Button>
              )}
            </div>
          )}
          <Button
            className="refreshButton"
            icon={<SyncOutlined spin={isLoading} />}
            onClick={() => ApproveAuctionsDataSocketEmition()}
          >
            Refresh
          </Button>
        </Space>
      </Flex>
      <div className="approve-table-container" style={{ paddingTop: 10 }}>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={filteredData}
          // dataSource={upcomingData}
          pagination={false}
          size="small"
          rowSelection={{ type: "checkbox", ...rowSelection }}
          // scroll={{ x: window.innerWidth }}
        />
        {/* {upcomingData.length !== 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <div>
              {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
                canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
                <Button
                  className={
                    canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
                      ? "submit-btn"
                      : "submit-btn disabled"
                  }
                  onClick={() => {
                    // onCheckBoxChange(upcomingData, "multi");
                    setModalConfirmation(true);
                    setCountdown(10);
                  }}
                >
                  Submit
                </Button>
              )}
            </div>
            <div>
              {(!canUserAccess(user, FeatureCodes.AUCTION_APPROVE_VIEW) ||
                canUserAccess(user, FeatureCodes.AUCTION_CHECKER)) && (
                <Button
                  className={
                    canUserAccess(user, FeatureCodes.AUCTION_CHECKER)
                      ? "cancel-btn"
                      : "cancel-btn disabled"
                  }
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    confirm({
                      title: "Cancel Auction",
                      icon: <ExclamationCircleOutlined />,
                      content:
                        "Are you sure you want to cancel the selected auction ?",
                      okText: "Yes",
                      cancelText: "No",
                      onOk() {
                        onCancelClick(upcomingData);
                      },
                      onCancel() {},
                    });
                  }}
                >
                  Cancel
                </Button>
              )}
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};
const mapStateToProps = createStructuredSelector({
  branches: selectBranches,
  crops: selectCrops,
  selectedCropId: selectSelectedCrop,
  selectedBranchId: selectSelectedBranch,
  user: selectUserData,
  auth: selectAuthData,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
  freezingTime: selectFreezingTime,
  parametersData: selectDefaultParams,
  minQuantity: selectMinQty,
  rebates: selectRebates,
  bagType: selectBagtypeList,
  divisions: selectDivisionList,
  varieties: selectVarieties,
});

export default connect(mapStateToProps)(ApproveAuction);
